<template>
  <div>
    <v-container
      id="regular-tables"
      fluid
      tag="section"
    >
      <v-data-table
        :headers="headers"
        :items="entidadesTecnicas"
        item-key="name"
        class="elevation-1"
        :search="search"
        :loading="loading"
      >

        <template v-slot:top>
          <v-row
            class="pa-4"
          >
          <v-col>
              <v-btn
                color="primary"
                :loading="isLoadingDownload"
              @click="exportarExcel"
              >
                Descargar data
                <v-icon> mdi-download </v-icon>
              </v-btn>
          </v-col>
            <v-col
              class="py-0 my-0"
            >
              <v-text-field
                v-model="search"
                label="Buscar en entidad tecnica..."
                outlined
              />
            </v-col>
            
          </v-row>
          
        </template>

        <template v-slot:[`item.direccion_fiscal`]="{ item }">
          {{ item.direccion_fiscal!==undefined ? item.direccion_fiscal.substring(0,20) : '' }}
          {{
            (item.direccion_fiscal !== undefined)? ( item.direccion_fiscal.length > 20 ? "..." : "" ) : "" 
          }}
          <v-icon 
            v-if="item.verificado_direccion_fiscal_gps !== '0'"
            color="success"
          >
            mdi-eye-check-outline
          </v-icon>
        </template>

        <template v-slot:[`item.direccion_real`]="{ item }">
          {{ item.direccion_real!==undefined ? item.direccion_real.substring(0,20) : '' }}
          {{
            (item.direccion_real !== undefined)? ( item.direccion_real.length > 20 ? "..." : "" ) : "" 
          }}
          <v-icon 
            v-if="item.verificado_direccion_real_gps !== '0'"
            color="success"
          >
            mdi-eye-check-outline
          </v-icon>
        </template>

        <template v-slot:[`item.accions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                @click="editarEntidadTecnica(item)"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip 
            v-if="isAdmin"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="dialogDelete(item)"
              >
                mdi-trash-can-outline
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2 ml-2"
                v-bind="attrs"
                @click="agregarContactosDeEntidadTecnica(item)"
                v-on="on"
              >
                mdi-card-account-phone
              </v-icon>
            </template>
            <span>Contactos</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="verificarDireccion(item)"
              >
                  mdi-clipboard-text-outline
              </v-icon>
            </template>
            <span>Prospección</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="comentariosEntidadTecnica(item)"
              >
                mdi-comment-quote
              </v-icon>
            </template>
            <span>Comentarios</span>
          </v-tooltip>
        </template>

      </v-data-table>
    </v-container>

    <!-- <v-btn
      class="mx-2"
      right
      absolute
      fab
      dark
      color="indigo"
      @click="newEntidadTecnica"
    >
      <v-icon dark>
        mdi-plus
      </v-icon>
    </v-btn> -->

    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          right
          absolute
          dark
          fab
          v-bind="attrs"
          v-on="on"
        >
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          link
          @click="newEntidadTecnica"
        >
          <v-list-item-title>Agregar individual</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="isAdmin"
          link
          @click="uploadExcel"
        >
          <v-list-item-title>Agregar por Excel</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="isAdmin"
          link
          @click="uploadExcelDB"
        >
          <v-list-item-title>Agregar Entidades</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <new-entidad-tecnica
      ref="newEntidadTecnica"
      @onCreate="onCreate"
    />
    <agregar-por-excel
      ref="uploadExcel"
      @onUploadExcel="onUploadExcel"
    />

    <upload-entidades-tecnicas
      ref="uploadExcelDB"
      @onUploadExcel2="onUploadExcel"
    />
    
    <dialog-personalizado
      ref="dialogEntidades"
      @onDialog="onDialog"
    />

    <view-map-component
      ref="viewMap"
      @onDialog="onDialog"
    />

    <wait-gps-component
    :dialog-wait-gps="dialogWaitGps"
    >
    </wait-gps-component>

    <comentarios
      ref="comentarios"
      @onComentario="onComentario"
    />

  </div>
</template>

<script>

  import NewEntidadTecnica from './components/NewEntidadTecnica.vue'
  import DialogPersonalizado from '../components/Dialog.vue'
  import AgregarPorExcel from './components/AgregarPorExcel.vue'
  import ViewMapComponent from './ViewMapComponent.vue'
  import WaitGpsComponent from './components/WaitGpsComponent.vue'
  import Comentarios from './../comentarios/Comentarios.vue'
  import UploadEntidadesTecnicas from './components/UploadEntidadesTecnicas.vue'

  import xlsx from 'json-as-xlsx'
  import firebase from 'firebase'

  const db = firebase.firestore()

  export default {
    components: {
      NewEntidadTecnica,
      DialogPersonalizado,
      AgregarPorExcel,
      ViewMapComponent,
      WaitGpsComponent,
      Comentarios,
      UploadEntidadesTecnicas
    },
    data () {
      return {
        loading: false,
        dialogWaitGps: false,
        Latitude: 0,
        Longitude: 0,
        zoomMap: 13,
        search: '',
        headers: [
          { text: 'RUC', value: 'ruc' },
          { text: 'Razon Social', value: 'razon_social' },
          { text: 'Direccion Fiscal', value: 'direccion_fiscal' },
          // { text: 'Representante Legal', value: 'representanteLegal' },
          { text: 'Direccion Real', value: 'direccion_real' },
          { text: 'Zona', value: 'zona' },
          { text: 'Estado', value: 'estado' },
          { text: 'Accions', value: 'accions' },

        ],
        entidadesTecnicas: [],
        isLoadingDownload: false,
        comentarios: [],
        contactos: [],
        dataTableLoading: false,
      }
    },
    computed: {
      isAdmin () {
        return JSON.parse(localStorage.userAuth).perfil !== 'Administrador' ? false : 'a'
      },
    },
    mounted () {
      this.getEntidadesTecnicas()
    },
    methods: {
      newEntidadTecnica () {
        this.$refs.newEntidadTecnica.open()
      },
      onCreate () {
        this.getEntidadesTecnicas()
      },
      async getEntidadesTecnicas () {
        this.loading = true
        this.entidadesTecnicas = []
        if (this.isAdmin) {
          // await db.collection('EntidadesTecnicas').get().then(entidades => {
          //   entidades.forEach(proyecto => {
          //     this.entidadesTecnicas.push(proyecto.data())
          //   })
          // })

          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad')
          const data = await response.json()
          this.entidadesTecnicas = data.data
        } else {
          // await db.collection('EntidadesTecnicas').where('emailUser', '==', JSON.parse(localStorage.userAuth).email).get().then(entidades => {
          //   entidades.forEach(proyecto => {
          //     this.entidadesTecnicas.push(proyecto.data())
          //   })
          // })
          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/user', {
                                    method: 'GET',
                                    headers: {
                                                'Content-type': 'application/json;charset=UTF-8',
                                                email_user: JSON.parse(localStorage.userAuth).email
                                              }
                                  })
          const data = await response.json()
          this.entidadesTecnicas = data.data
        }
        this.loading = false
        // await this.obtenerComentarios()
        // await this.obtenerContactos()
      },
      editarEntidadTecnica (entidadTecnica) {
        this.$refs.newEntidadTecnica.open(entidadTecnica)
      },
      dialogDelete (item) {
        this.$refs.dialogEntidades.open('Eliminar entidad técnica', '¿Esta seguro de eliminar esta entidad tecnica?', item)
      },
      onDialog (data) {
        this.eliminarEntidadTecnica(data)
      },
      async eliminarEntidadTecnica (entidadTecnica) {
        // db.collection('EntidadesTecnicas').doc(entidadTecnica.id).delete().then(() => {
        //   this.$refs.dialogEntidades.close()
        //   this.getEntidadesTecnicas()
        // })
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/' + entidadTecnica.id, {
                                    method: 'DELETE',
                                    headers: {
                                                'Content-type': 'application/json;charset=UTF-8',
                                              }
                                  })
        const data = await response.json()
        if (data.success) {}

        this.$refs.dialogEntidades.close()
        this.getEntidadesTecnicas()
      },
      uploadExcel () {
        this.$refs.uploadExcel.open()
      },
      onUploadExcel () {
        this.getEntidadesTecnicas()
      },
      verificarDireccion (item) {
        this.$router.push({ name: 'verificacion direccion', params: { item: item } })
      },
      agregarContactosDeEntidadTecnica (item) {
          this.$router.push({ name: 'contactos de entidades tecnicas', params: { entidadId: item.id } })
      },
      onVerificar () {
      },
      comentariosEntidadTecnica (item) {
        this.$refs.comentarios.open(item)
        // this.$router.push({ name: 'comentarios', params: { entidadId: item.id } })
      },
      onComentario () {
        this.getEntidadesTecnicas()
      },
      async exportarExcel () {
        try {
          this.isLoadingDownload = true
        
          const data = [
            {
              sheet: 'Campañas',
              columns: [
                { label: 'RUC', value: 'ruc' },
                { label: 'RAZON SOCIAL', value: 'razon_social' },
                { label: 'DIRECIÓN FISCAL', value: 'direccion_fiscal' },
                { label: 'DIRECIÓN REAL', value: 'direccion_real' },
                { label: 'ZONA', value: 'zona' },
                { label: 'ESTADO', value: 'estado' },
                { label: 'VIGENCIA', value: 'vigencia' },
                { label: 'EMAIL', value: 'email_user' },
                { label: 'MEDIO DE CONTACTO', value: 'medio_de_contacto' },
                { label: 'PROVEEDOR ACTUAL', value: 'proveedor_actual' },
                { label: 'DEPARTAMENTO FISCAL', value: 'departamento_fiscal' },
                { label: 'PROVINCIA FISCAL', value: 'provincia_fiscal' },
                { label: 'DEPARTAMENTO REAL', value: 'departamento_real' },
                { label: 'PROVINCIA REAL', value: 'provincia_real' },
                { label: 'REPRESENTANTE LEGAL', value: 'representante_legal' },
                { label: 'TIPO DE CLIENTE', value: 'tipo_de_cliente' },
                { label: 'TIPO DE CONSTRUCCION', value: 'tipo_de_construccion' },
                // { label: 'CANTIDAD DE MODULOS', value: (row) => (row.cantidad_deModulos ? row.cantidadDeModulos.toString() : '') },
                // { label: 'CANTIDAD DE CONVOCATORIAS', value: (row) => (row.convocatorias ? row.convocatorias.toString() : '') },
                { label: 'FOTO DIRECCION FISCAL', value: 'foto_direccion_fiscal' },
                { label: 'FOTO DIRECCION REAL', value: 'foto_direccion_real' },
                { label: 'MEDIO DE CONTACTO', value: 'medio_de_contacto' },
                { label: 'VERIFICADO DIRECCION FISCAL', value: 'verificado_direccion_fiscal_gps' },
                { label: 'VERIFICADO DIRECCION REAL', value: 'verificado_direccion_real_gps' },
                { label: 'LATITUD FISCAL', value: 'latitud_fiscal_gps' },
                { label: 'LONGITUD FISCAL', value: 'longitud_fiscal_gps' },
                { label: 'LATITUD REAL', value: 'latitud_real_gps' },
                { label: 'LONGITUD REAL', value: 'longitud_real_gps' },
                { label: 'CONTACTOS', value: 'contactos' },
                { label: 'COMENTARIOS', value: 'comentarios' },
              ],
              // content: [
              //   ...payload.data
              // ]
              content: [
                ...this.entidadesTecnicas
              ]
            }]
  
          const settings = {
            sheetName: 'Data',
            fileName: 'Entidades Tecnicas'
          }
  
          await xlsx(data, settings)
          this.isLoadingDownload = false
        } catch (error) {
          this.isLoadingDownload = false
        }
      },
      async obtenerComentarios () {
        this.entidadesTecnicas.forEach((entidadtecnica) => {
          db.collection('commentary').where('technicalEntity', '==', entidadtecnica.id || '').get()
          .then(entidades => {
            this.comentarios = []
            entidades.forEach(proyecto => {
              const data = {
                ususario: proyecto.data().emailName || '',
                comentario: proyecto.data().commentary || '',
              }
              this.comentarios.push(data)
            })
            entidadtecnica.comentarios = JSON.stringify(this.comentarios)
          })
        })
      },
      async obtenerContactos () {
        this.entidadesTecnicas.forEach((entidadtecnica) => {
          db.collection('contacts').where('technicalEntity', '==', entidadtecnica.id || '').get()
          .then(entidades => {
            this.contactos = []
            entidades.forEach(proyecto => {
              const data = {
                Contacto: proyecto.data().contactName,
                Telefono: proyecto.data().contactTelephone,
                Email: proyecto.data().emailContact,
              }
              this.contactos.push(data)
            })
            entidadtecnica.contactos = JSON.stringify(this.contactos)
          })
        })
      },
      uploadExcelDB () {
        this.$refs.uploadExcelDB.open()
      }
    },
  }
</script>
